import { render, staticRenderFns } from "./TheTickets.vue?vue&type=template&id=4249443c&"
import script from "./TheTickets.vue?vue&type=script&lang=js&"
export * from "./TheTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports